import { render } from "./DesignDetailPage.vue?vue&type=template&id=55fdc224&scoped=true&ts=true"
import script from "./DesignDetailPage.vue?vue&type=script&lang=ts"
export * from "./DesignDetailPage.vue?vue&type=script&lang=ts"

import "./DesignDetailPage.vue?vue&type=style&index=0&id=55fdc224&scoped=true&lang=css"

import exportComponent from "/home/runner/work/flowerdiy/flowerdiy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55fdc224"]])

export default __exports__